import { render, staticRenderFns } from "./api-classification.vue?vue&type=template&id=6090b732&"
import script from "./api-classification.vue?vue&type=script&lang=js&"
export * from "./api-classification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports